import { MoreHorizontal, Trash2, Flag, Pin, VolumeX, UserX } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function MessageActions({ msg, me, act, api }) {
  const report = () => {
    const reason = window.prompt("Why are you reporting this message? (optional)");
    if (reason === null) return;
    act(() => api.post(`/community/messages/${msg.id}/report`, { reason: reason.slice(0, 300) }), "Thanks — the CarrierLaunch team will review it.");
  };
  const del = () => {
    if (window.confirm("Delete this message for everyone?")) act(() => api.delete(`/community/messages/${msg.id}`), "Message deleted");
  };
  const status = (s, label) => {
    if (window.confirm(`${label} ${msg.author_first} (${msg.author_business})?`)) {
      act(() => api.post(`/admin/community/members/${msg.author_uid}/status`, { status: s }), `${msg.author_first} ${s === "muted" ? "muted" : "removed"}`);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button aria-label="Message actions" data-testid={`community-msg-actions-${msg.id}`}
          className="self-start w-9 h-9 flex items-center justify-center text-muted-foreground hover:text-white sm:opacity-0 sm:group-hover:opacity-100 focus:opacity-100 transition-opacity">
          <MoreHorizontal size={16} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0A0A0A] border-[#262626]">
        {me.is_mod && (
          <DropdownMenuItem data-testid={`community-msg-pin-${msg.id}`} onSelect={() => act(() => api.post(`/admin/community/messages/${msg.id}/pin`, { pinned: !msg.pinned }), msg.pinned ? "Unpinned" : "Pinned to Resources")}>
            <Pin size={14} className="mr-2" /> {msg.pinned ? "Unpin" : "Pin to Resources"}
          </DropdownMenuItem>
        )}
        {!msg.mine && (
          <DropdownMenuItem data-testid={`community-msg-report-${msg.id}`} onSelect={report}><Flag size={14} className="mr-2" /> Report</DropdownMenuItem>
        )}
        {(msg.mine || me.is_mod) && (
          <DropdownMenuItem data-testid={`community-msg-delete-${msg.id}`} onSelect={del} className="text-[#F87171]"><Trash2 size={14} className="mr-2" /> Delete</DropdownMenuItem>
        )}
        {me.is_mod && !msg.author_is_team && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid={`community-msg-mute-${msg.id}`} onSelect={() => status("muted", "Mute")}><VolumeX size={14} className="mr-2" /> Mute author</DropdownMenuItem>
            <DropdownMenuItem data-testid={`community-msg-remove-${msg.id}`} onSelect={() => status("removed", "Remove")} className="text-[#F87171]"><UserX size={14} className="mr-2" /> Remove author</DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
